import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        VRow,
        { staticClass: "mt-0", attrs: { "no-gutters": "" } },
        [
          _c(VSpacer),
          _c(
            VCol,
            { attrs: { cols: "4" } },
            [
              _c(VSelect, {
                attrs: {
                  items: _vm.diagnosticos,
                  "item-text": "nome",
                  "item-value": "id",
                  label: "Diagnóstico:",
                  "return-object": "",
                },
                model: {
                  value: _vm.diagnostico,
                  callback: function ($$v) {
                    _vm.diagnostico = $$v
                  },
                  expression: "diagnostico",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VRow,
        [
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c("v-card-widget", { attrs: { title: "Informações" } }, [
                _c(
                  "div",
                  { attrs: { slot: "widget-content" }, slot: "widget-content" },
                  [
                    _c(
                      VRow,
                      { attrs: { "no-gutters": "" } },
                      [
                        _c(VCol, { attrs: { cols: "6" } }, [
                          _c("span", { staticClass: "font-weight-bold" }, [
                            _vm._v("Usuário: "),
                          ]),
                          _c("span", { staticClass: "font-weight-light" }, [
                            _vm._v(_vm._s(_vm.usuario.nome)),
                          ]),
                        ]),
                        _vm.unidade.id
                          ? _c(VCol, { attrs: { cols: "6" } }, [
                              _c("span", { staticClass: "font-weight-bold" }, [
                                _vm._v("Unidade: "),
                              ]),
                              _c("span", { staticClass: "font-weight-light" }, [
                                _vm._v(
                                  _vm._s(
                                    `${_vm.unidade.sigla} - ${_vm.unidade.nome}`
                                  )
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c(
                "v-card-widget",
                {
                  attrs: {
                    "enable-actions": false,
                    title: "Gerenciamento de Dispensas do Diagnóstico",
                  },
                },
                [
                  _vm.diagnostico
                    ? _c(
                        "div",
                        {
                          attrs: { slot: "widget-content" },
                          slot: "widget-content",
                        },
                        [
                          _vm.diagnostico.status === "FUTURO"
                            ? _c(
                                VRow,
                                { attrs: { "no-gutters": "" } },
                                [
                                  _c(
                                    VCol,
                                    { attrs: { cols: "12" } },
                                    [
                                      _c("dispensa-form", {
                                        attrs: {
                                          diagnostico: _vm.diagnostico,
                                          dispensas: _vm.dispensas,
                                          motivos: _vm.motivos,
                                          "is-edicao": _vm.isEdicao,
                                          "dispensa-update": _vm.dispensaUpdate,
                                        },
                                        on: {
                                          return: (value) =>
                                            _vm.addDispensa(value),
                                          motivo: (value) =>
                                            _vm.addMotivo(value),
                                          deleteMotivo: (value) =>
                                            _vm.excluirMotivo(value),
                                          reset: () => _vm.reset(),
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _c(
                                VRow,
                                { attrs: { "no-gutters": "" } },
                                [
                                  _c(
                                    VCol,
                                    { attrs: { cols: "12" } },
                                    [
                                      _c("app-alert", {
                                        staticClass: "ma-4",
                                        attrs: { message: _vm.mensagemPrazo },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                          _c(
                            VRow,
                            { attrs: { "no-gutters": "" } },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "12" } },
                                [
                                  _c("dispensa-list", {
                                    attrs: {
                                      diagnostico: _vm.diagnostico,
                                      dispensas: _vm.dispensas,
                                      motivos: _vm.motivos,
                                    },
                                    on: {
                                      update: (value) => _vm.editar(value),
                                      delete: (value) => _vm.excluir(value),
                                      reset: () => _vm.reset(),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        {
                          attrs: { slot: "widget-content" },
                          slot: "widget-content",
                        },
                        [
                          _c(
                            VRow,
                            { attrs: { "no-gutters": "" } },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "12" } },
                                [
                                  _c("app-alert", {
                                    staticClass: "ma-4",
                                    attrs: {
                                      icon: "warning",
                                      message:
                                        "Selecione o diagnóstico para prosseguir",
                                      type: "warning",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }